







import Vue from 'vue';
import notranslate from '@/components/ds/notranslate';

// O email vem dos dados pessoais da matrícula (o aluno ligado ao `admissions-auth-token`),
// não do POCKET: a sessão Descomplica do navegador é compartilhada e pode ser de outra pessoa.
export default Vue.extend({
  directives: { notranslate },
  computed: {
    email(): string {
      return this.$store.getters.personalData?.email || '';
    },
  },
});
